export const LOGIN_PATH = `/_hcms/mem/login`;
export const LOGIN_VERIFY_PATH = `/_hcms/customerportal/v1/login-verify`;
export const LOGOUT_PATH = '/_hcms/mem/logout';
export const FORM_DATA_PATH = `/_hcms/customerportal/v1/layout/form-version`;
export const PORTAL_DATA_PATH = `/_hcms/customerportal/v1/portal-data`;
export const TICKET_BASE_PATH = `/_hcms/customerportal/v1/ticket`;
export const TICKET_CLOSE_BASE_PATH = `${TICKET_BASE_PATH}/close`;
export const TICKET_EXPORT_CSV_PATH = `${TICKET_BASE_PATH}/export/csv`;
export const TICKET_LISTINGS_PATH = `${TICKET_BASE_PATH}/search`;
export const TICKET_THREAD_VIEW_BASE_PATH = `/_hcms/customerportal/v1/threadview`;
export const PUBLISH_MESSAGE_BASE_PATH = `/_hcms/customerportal/v1/publish`;
export const FILE_UPLOAD_URL_PATH = `/_hcms/customerportal/v1/attachment/upload-url`;
export const FILE_MANAGER_BASE_PATH = `/_hcms/customerportal/filemanager`;
export const TICKET_RELEVANT_THREADS_BASE_PATH = `/_hcms/customerportal/v1/threadview/relevant-threads`;
export const THREAD_ATTACHMENTS_BASE_PATH = `/_hcms/customerportal/v1/attachment/thread`;

/* == Preview Endpoints == */
export const PREVIEW_PORTAL_DATA_PATH = `/_hcms/customerportal/v2/preview/portal-data`;
export const PREVIEW_FORM_DATA_PATH = `/_hcms/customerportal/v2/preview/form-version`;
export const PREVIEW_THREAD_VIEW_BASE_PATH = `/_hcms/customerportal/v2/preview/thread-view`;
export const PREVIEW_TICKET_BASE_PATH = `/_hcms/customerportal/v2/preview/ticket`;